import { AudioStreamFormat } from "../../models/microphone";

export const MIC_DFLT_MSG = {
  ALLOW_PERMISSION: "Please allow the microphone permission",
  ERROR_RUNTIME: "An error has occurred during the recording, please try it.",
  ERROR_INIT:
    "Microphone could not be initialised. Does the browser support it?",
  PRESS_TO_STOP: "Please press the stop button to stop recording",
  TAP_TO_RECORD: "Please tap to start record"
};

export const DEFAULT_AUDIO_STREAM: AudioStreamFormat = {
  samplePerSec: 16000,
  channelsCount: 1,
  bitsPerSample: 16
};
